import http from './base/http';

// 充值管理
export function rechargeManage(data) {
  const params = { // http请求的参数
    SERVICE_ID: '10014',
    OTYPE: 2,
    USER_ID: parseInt(sessionStorage.getItem('userId')),
    SESSION: sessionStorage.getItem('session'),
    TC_ID: parseInt(sessionStorage.getItem('companyId')),
    ...data,
  };
  return http.post(params);
}
// 新增充值方式
export function addRecharge(data) {
  const params = { // http请求的参数
    SERVICE_ID: '10014',
    OTYPE: 1,
    USER_ID: parseInt(sessionStorage.getItem('userId')),
    SESSION: sessionStorage.getItem('session'),
    TC_ID: parseInt(sessionStorage.getItem('companyId')),
    ...data,
  };
  return http.post(params);
}



// WEBPACK FOOTER //
// ./src/api/rechargeApi.js